export default "__VITE_PUBLIC_ASSET__7c5afcd7__"